const DOWN_ARROW = 40;
const LEFT_ARROW = 37;
const RIGHT_ARROW = 39;
const UP_ARROW = 38;

export { DOWN_ARROW, LEFT_ARROW, RIGHT_ARROW, UP_ARROW };
